module.exports = __webpack_public_path__ + "assets/img/media.1a2f8ea0.svg";